import { get } from "idb-keyval";
import { getLocalStorage } from "./SaveIndexBD";

export const GetIndexBD = async(chave) => {
  try {
    const data = getLocalStorage(chave, true);
    return data || null;
  } catch (error) {
    console.error("Erro ao obter dados do IndexedDB:", error);
    throw error;
  }
}